<template>
  <div class="marketBoard" ref="w">
    <!-- 顶部区域 -->
    <div class="f1 mb-30">
      <div class="d1 fz21">
        积木云系统中创建的人群营销、优惠券营销、场景营销皆会进入营销看板
      </div>
      <div class="d2">
        <div class="text">
          <!-- <img src="../../assets/images/newIcon/popupwindow_background.png" alt=""> -->
          查看积木云场景分析方法论，快来体验数字化增长的魅力吧～
        </div>
        <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="" />
      </div>
    </div>
    <!-- 两个切换按钮 -->
    <div class="f2 mb-30">
      <div class="bf" :class="types == 1 ? 'active' : ''" @click="chagef2(1)">
        <img
          v-show="types != 1"
          src="../../assets/images/newIcon/channelkb_pepole_icon.png"
          alt=""
        />
        <img
          v-show="types == 1"
          src="../../assets/images/newIcon/channelkb_senariowhite_icon.png"
          alt=""
        />
        <p>
          <span>人群营销</span>
          <span>36,254</span>
        </p>
      </div>
      <div
        class="bf"
        :class="types == 2 ? 'active' : ''"
        @click="chagef2(2)"
        style="margin-left: 22px"
      >
        <img
          v-show="types != 2"
          src="../../assets/images/newIcon/channelkb_senario_icon.png"
          alt=""
        />
        <img
          v-show="types == 2"
          src="../../assets/images/newIcon/channelkb_senariowhite_icon (1).png"
          alt=""
        />
        <p>
          <span>场景营销</span>
          <span>36,254</span>
        </p>
      </div>
    </div>
    <!-- input框区域 -->
    <el-card shadow="never" class="inputBox">
      <div class="top6 clearfix">
        <div class="fl">
          <el-form class="form" ref="form" :model="form" label-width="80px">
            <el-form-item class="search">
              <el-input
                v-model="form.name"
                placeholder="请输入关键词"
                suffix-icon="el-icon-search"
              ></el-input>
            </el-form-item>
            <el-form-item label="业务系统：">
              <el-select v-model="form.region" placeholder="请选择业务系统">
                <el-option label="小橘帮帮" value="shanghai"></el-option>
                <el-option label="颐安中台" value="beijing"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <!-- 右侧区域 -->
        <div class="fr">
          <p>
            <img
              src="../../assets/images/newIcon/ss_shaixuan_icon.png"
              alt=""
            />
            <el-select
              style="width: 110px"
              v-model="def"
              placeholder="请选择业务系统"
              class="my-select"
            >
              <el-option
                v-for="item in options1"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </p>
        </div>
      </div>
    </el-card>
    <!-- 小卡片区域 -->
    <el-card class="card3" shadow="never">
      <div class="b1">
        <p>
          <span class="fz16">待开始</span><span class="fz14 radBule">99+</span>
        </p>
        <ul>
          <li @click="$router.push('/marketAnalyse/details')">
            <div class="d1">
              <div>
                <span
                  style="
                    display: inline-block;
                    transform: translate(-15px, 0px);
                  "
                >
                  <img
                    style="
                      display: inline-block;
                      transform: translate(0px, 3px);
                    "
                    src="../../assets/images/newIcon/jimu_people_icon.png"
                    alt=""
                  />
                  提升用户留资下单
                </span>
                <span class="b"> 人群 </span>
              </div>
              <div>
                <span>创建时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div>
                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                <span class="c0091FF">待开始</span>
              </div>
              <div class="jdt">
                <span>触达人数：</span>
                <span>—</span>
              </div>
            </div>
          </li>
          <li>
            <div class="d1">
              <div>
                <span
                  style="
                    display: inline-block;
                    transform: translate(-15px, 0px);
                  "
                >
                  <img
                    style="
                      display: inline-block;
                      transform: translate(0px, 3px);
                    "
                    src="../../assets/images/newIcon/jimu_people_icon.png"
                    alt=""
                  />
                  47小时内活跃-流转
                </span>
                <span class="c b5"> 场景 </span>
              </div>
              <div>
                <span>创建时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div>
                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                <span class="c0091FF">待开始</span>
              </div>
              <div class="jdt">
                <span>触达人数：</span>
                <span>—</span>
              </div>
            </div>
          </li>
          <li>
            <div class="d1">
              <div>
                <span
                  style="
                    display: inline-block;
                    transform: translate(-15px, 0px);
                  "
                >
                  <img
                    style="
                      display: inline-block;
                      transform: translate(0px, 3px);
                    "
                    src="../../assets/images/newIcon/jimu_people_icon.png"
                    alt=""
                  />
                  提升用户留资下单
                </span>
                <span class="b"> 人群 </span>
              </div>
              <div>
                <span>创建时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div>
                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                <span class="c0091FF">待开始</span>
              </div>
              <div class="jdt">
                <span>触达人数：</span>
                <span>—</span>
              </div>
            </div>
          </li>
          <li>
            <div class="d1">
              <div>
                <span
                  style="
                    display: inline-block;
                    transform: translate(-15px, 0px);
                  "
                >
                  <img
                    style="
                      display: inline-block;
                      transform: translate(0px, 3px);
                    "
                    src="../../assets/images/newIcon/jimu_people_icon.png"
                    alt=""
                  />
                  24小时签到打卡
                </span>
                <span class="b"> 人群 </span>
              </div>
              <div>
                <span>创建时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div>
                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                <span class="c0091FF">待开始</span>
              </div>
              <div class="jdt">
                <span>触达人数：</span>
                <span>—</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="b2">
        <p>
          <span class="fz16">执行中（单次）</span
          ><span class="fz14 radBule">99+</span>
        </p>
        <ul>
          <li>
            <div class="d1">
              <div>
                <span class="txt-left">
                  <img
                    style="
                      display: inline-block;
                      transform: translate(0px, 3px);
                    "
                    src="../../assets/images/newIcon/jimu_people_icon.png"
                    alt=""
                  />
                  挽回流失用户
                </span>
                <span class="b"> 人群 </span>
              </div>
              <div>
                <span>创建时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div>
                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                <span class="c0091FF colorGree">执行中</span>
              </div>
              <div class="jdt"></div>
              <div class="time">
                <span>最新触发时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div class="d33">
                <div>
                  <p class="blueColor">33.00%</p>
                  <p class="target">
                    目标完成率比前一天<span class="downColor"
                      >5.9%<i class="el-icon-bottom"></i
                    ></span>
                  </p>
                </div>
                <div id="y1" style="margin-top: 10px; margin-left: -30px"></div>
              </div>
            </div>

            <div class="d2"></div>
          </li>
          <li>
            <div class="d1">
              <div>
                <span class="txt-left">
                  <img
                    style="
                      display: inline-block;
                      transform: translate(0px, 3px);
                    "
                    src="../../assets/images/newIcon/jimu_people_icon.png"
                    alt=""
                  />
                  关注公众号47小时
                </span>
                <span class="c"> 场景 </span>
              </div>
              <div>
                <span>创建时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div>
                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                <span class="c0091FF colorGree">执行中</span>
              </div>
              <div class="jdt"></div>
              <div class="time">
                <span>最新触发时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div class="d33">
                <div>
                  <p class="blueColor">33.00%</p>
                  <p class="target">
                    目标完成率比前一天<span class="downColor"
                      >5.9%<i class="el-icon-bottom"></i
                    ></span>
                  </p>
                </div>
                <div id="y2" style="margin-top: 10px; margin-left: -30px"></div>
              </div>
            </div>

            <div class="d2"></div>
          </li>
          <li>
            <div class="d1">
              <div>
                <span class="txt-left">
                  <img
                    style="
                      display: inline-block;
                      transform: translate(0px, 3px);
                    "
                    src="../../assets/images/newIcon/jimu_people_icon.png"
                    alt=""
                  />
                  挽回流失用户
                </span>
                <span class="b"> 人群 </span>
              </div>
              <div>
                <span>创建时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div>
                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                <span class="c0091FF colorGree">执行中</span>
              </div>
              <div class="jdt"></div>
              <div class="time mart">
                <span>最新触发时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div class="d33 mart">
                <div>
                  <p class="blueColor">33.00%</p>
                  <p class="target">
                    目标完成率比前一天<span class="downColor"
                      >5.9%<i class="el-icon-bottom"></i
                    ></span>
                  </p>
                </div>
                <div id="y3" style="margin-top: 10px; margin-left: -30px"></div>
              </div>
            </div>

            <div class="d2"></div>
          </li>
        </ul>
      </div>
      <div class="b3">
        <p>
          <span class="fz16">执行中（重复）</span
          ><span class="fz14 radBule">99+</span>
        </p>
        <ul>
          <li>
            <div class="d1">
              <div>
                <span class="txt-left">
                  <img
                    style="
                      display: inline-block;
                      transform: translate(0px, 3px);
                    "
                    src="../../assets/images/newIcon/jimu_people_icon.png"
                    alt=""
                  />
                  挽回流失用户
                </span>
                <span class="b"> 人群 </span>
              </div>
              <div>
                <span>创建时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div>
                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                <span class="c0091FF colorGree">执行中</span>
              </div>
              <div class="jdt"></div>
              <div class="time">
                <span>最新触发时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div class="d33">
                <div>
                  <p class="blueColor">33.00%</p>
                  <p class="target">
                    目标完成率比前一天<span class="downColor"
                      >5.9%<i class="el-icon-bottom"></i
                    ></span>
                  </p>
                </div>
                <div id="y4" style="margin-top: 10px; margin-left: -30px"></div>
              </div>
            </div>

            <div class="d2"></div>
          </li>
          <li>
            <div class="d1">
              <div>
                <span class="txt-left">
                  <img
                    style="
                      display: inline-block;
                      transform: translate(0px, 3px);
                    "
                    src="../../assets/images/newIcon/jimu_people_icon.png"
                    alt=""
                  />
                  关注公众号47小时
                </span>
                <span class="b"> 人群 </span>
              </div>
              <div>
                <span>创建时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div>
                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                <span class="c0091FF colorGree">执行中</span>
              </div>
              <div class="jdt"></div>
              <div class="time">
                <span>最新触发时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div class="d33">
                <div>
                  <p class="blueColor">33.00%</p>
                  <p class="target">
                    目标完成率比前一天<span class="downColor"
                      >5.9%<i class="el-icon-bottom"></i
                    ></span>
                  </p>
                </div>
                <div id="y5" style="margin-top: 10px; margin-left: -30px"></div>
              </div>
            </div>

            <div class="d2"></div>
          </li>
          <li>
            <div class="d1">
              <div>
                <span class="txt-left">
                  <img
                    style="
                      display: inline-block;
                      transform: translate(0px, 3px);
                    "
                    src="../../assets/images/newIcon/jimu_people_icon.png"
                    alt=""
                  />
                  挽回流失用户
                </span>
                <span class="b"> 人群 </span>
              </div>
              <div>
                <span>创建时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div>
                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                <span class="c0091FF colorGree">执行中</span>
              </div>
              <div class="jdt"></div>
              <div class="time mart">
                <span>最新触发时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div class="d33 mart">
                <div>
                  <p class="blueColor">33.00%</p>
                  <p class="target">
                    目标完成率比前一天<span class="downColor"
                      >5.9%<i class="el-icon-bottom"></i
                    ></span>
                  </p>
                </div>
                <div id="y6" style="margin-top: 10px; margin-left: -30px"></div>
              </div>
            </div>

            <div class="d2"></div>
          </li>
        </ul>
      </div>
      <!-- <div class="b4">
        <p>
          <span class="fz16">已结束（单次事件）</span
          ><span class="fz14 radBule">99+</span>
        </p>
        <ul>
          <li>
            <div class="d1">
              <div>
                <span class="txt-left">
                  <img
                    style="
                      display: inline-block;
                      transform: translate(0px, 3px);
                    "
                    src="../../assets/images/newIcon/jimu_people_icon.png"
                    alt=""
                  />
                  24小时签到打卡
                </span>
                <span class="c"> 场景 </span>
              </div>
              <div>
                <span>创建时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div>
                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                <span class="c0091FF bblurColor">完成</span>
              </div>
              <div class="jdt">
                <span>目标完成率：</span>
                <el-progress :percentage="25.44"></el-progress>
              </div>
            </div>

            <div class="d2"></div>
          </li>
          <li>
            <div class="d1">
              <div>
                <span class="txt-left">
                  <img
                    style="
                      display: inline-block;
                      transform: translate(0px, 3px);
                    "
                    src="../../assets/images/newIcon/jimu_people_icon.png"
                    alt=""
                  />
                  24小时签到打卡
                </span>
                <span class="b"> 人群 </span>
              </div>
              <div>
                <span>创建时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div>
                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                <span class="c0091FF bblurColor">完成</span>
              </div>
              <div class="jdt">
                <span>目标完成率：</span>
                <el-progress :percentage="25.44"></el-progress>
              </div>
            </div>
            <div class="d2"></div>
          </li>
        </ul>
      </div> -->
      <div class="b1 b5">
        <p>
          <span class="fz16">待开始</span><span class="fz14 radBule">99+</span>
        </p>
        <ul>
          <li @click="$router.push('/marketAnalyse/details')">
            <div class="d1">
              <div>
                <span
                  style="
                    display: inline-block;
                    transform: translate(-15px, 0px);
                  "
                >
                  <img
                    style="
                      display: inline-block;
                      transform: translate(0px, 3px);
                    "
                    src="../../assets/images/newIcon/jimu_people_icon.png"
                    alt=""
                  />
                  提升用户留资下单
                </span>
                <span class="b"> 人群 </span>
              </div>
              <div>
                <span>创建时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div>
                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                <span class="c0091FF">待开始</span>
              </div>
              <div class="jdt">
                <span>触达人数：</span>
                <span>—</span>
              </div>
            </div>
          </li>
          <li>
            <div class="d1">
              <div>
                <span
                  style="
                    display: inline-block;
                    transform: translate(-15px, 0px);
                  "
                >
                  <img
                    style="
                      display: inline-block;
                      transform: translate(0px, 3px);
                    "
                    src="../../assets/images/newIcon/jimu_people_icon.png"
                    alt=""
                  />
                  47小时内活跃-流转
                </span>
                <span class="c b5"> 场景 </span>
              </div>
              <div>
                <span>创建时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div>
                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                <span class="c0091FF">待开始</span>
              </div>
              <div class="jdt">
                <span>触达人数：</span>
                <span>—</span>
              </div>
            </div>
          </li>
          <li>
            <div class="d1">
              <div>
                <span
                  style="
                    display: inline-block;
                    transform: translate(-15px, 0px);
                  "
                >
                  <img
                    style="
                      display: inline-block;
                      transform: translate(0px, 3px);
                    "
                    src="../../assets/images/newIcon/jimu_people_icon.png"
                    alt=""
                  />
                  提升用户留资下单
                </span>
                <span class="b"> 人群 </span>
              </div>
              <div>
                <span>创建时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div>
                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                <span class="c0091FF">待开始</span>
              </div>
              <div class="jdt">
                <span>触达人数：</span>
                <span>—</span>
              </div>
            </div>
          </li>
          <li>
            <div class="d1">
              <div>
                <span
                  style="
                    display: inline-block;
                    transform: translate(-15px, 0px);
                  "
                >
                  <img
                    style="
                      display: inline-block;
                      transform: translate(0px, 3px);
                    "
                    src="../../assets/images/newIcon/jimu_people_icon.png"
                    alt=""
                  />
                  24小时签到打卡
                </span>
                <span class="b"> 人群 </span>
              </div>
              <div>
                <span>创建时间：</span>
                <span class="c3">2021.07.09 16:53</span>
              </div>
              <div>
                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                <span class="c0091FF">待开始</span>
              </div>
              <div class="jdt">
                <span>触达人数：</span>
                <span>—</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //按钮切换
      types: "1",
      def: "微信公众号",
      options1: [
        { name: "微信公众号" },
        { name: "push" },
        { name: "短信触发" },
        { name: "弹窗" },
      ],
      form: {
        name: "",
        region: "",
      },
      value: "",
      data: [
        { data: "6.21", name: "新增客户数", val: 1000 },
        { data: "6.22", name: "新增客户数", val: 750 },
        { data: "6.23", name: "新增客户数", val: 270 },
        { data: "6.24", name: "新增客户数", val: 380 },
        { data: "6.25", name: "新增客户数", val: 250 },
        { data: "6.26", name: "新增客户数", val: 250 },
      ],
    };
  },
  mounted() {
    this.$refs.w.style.zoom = window.screen.width/1920
    this.init("y1", this.data, 100);
    this.init("y2", this.data, 100);
    this.init("y3", this.data, 100);
    this.init("y4", this.data, 100);
    this.init("y5", this.data, 100);
    this.init("y6", this.data, 100);
  },
  methods: {
    //  顶部切换
    chagef2(n) {
      this.types = n;
    },
    // 线图
    init(id, data, height) {
      const chart = new this.$chart({
        container: id,
        autoFit: true,
        width: 100,
        height: height || 300,
      });
      // chart
      // .interval({
      //     theme: {
      //     defaultColor: 'red',
      //     },
      // })
      // .position(0);
      chart.data(data);
      chart.scale({
        month: {
          range: [0, 1],
        },
        temperature: {
          nice: true,
        },
      });
      chart.scale("val", {
        min: 0,
        max: 1000,
      });
      chart.tooltip(false); //关闭提示信息
      chart.axis(false); // 关闭坐标轴
      // 隐藏图例
      chart.legend(false);
      chart.line().position("data*val").shape("smooth").color("name");
      // chart.point().position("data*val").shape("circle");
      chart.render();
    },
  },
};
</script>

<style lang="less">
.marketBoard {
 zoom: 1;
  padding: 30px;
  // 顶部区域
  .f1 {
    display: flex;
    justify-content: space-between;
    .d1 {
      height: 106px;
      box-sizing: border-box;
      padding-right: 6%;
      padding-left: 4%;
      padding-top: 30px;
      width: 65%;
      background: url("../../assets/images/newIcon/jijmu_title_bg.png")
        no-repeat;
      background-size: 100% 100%;
      font-size: 21px;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
      letter-spacing: 7px;
    }
    .d2 {
      width: 34%;
      display: flex;
      align-items: center;
      height: 106px;
      .text {
        display: flex;
        align-items: center;

        padding: 4px 30px;
        // background: #fff;
        height: 100%;
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        img {
          width: 305px;
        }
        span {
          font-size: 14px;
          font-weight: 500;
          color: #327eff;
        }
        background: url("../../assets/images/newIcon/popupwindow_background.png")
          no-repeat;
        background-size: 100% 100%;
      }

      img {
        width: 58px;
        height: 58px;
      }
    }
  }
  //   两个按钮区域
  .f2 {
    display: flex;
    // justify-content: space-between;
    div {
      width: 23%;
      min-width: 270px;
      height: 150px;
      display: flex;
      align-items: center;
      padding: 30px 60px;
      box-sizing: border-box;
      border-radius: 8px;
      img {
        width: 66px;
        height: 66px;
      }
      p {
        margin-left: 15px;
        span {
          display: block;
          &:first-child {
            font-size: 16px;
            font-weight: 400;
            color: #333333;
          }
          &:last-child {
            margin-top: 10px;
            font-size: 30px;
            font-weight: bold;
            color: #333333;
            line-height: 35px;
          }
        }
      }
    }
    .active {
      background: #327eff;
      span {
        color: #fff !important;
      }
    }
  }
  //input框区域
  .inputBox {
    height: 76px;
    .top6 {
      margin-top: -5px;
      .fl {
        float: left;
        font-size: 16px;
        border-radius: 18px;

        .form {
          display: flex;
          align-items: center;
          .el-form-item {
            margin-top: 8px;
          }
          .search {
            .el-form-item__content {
              margin-left: 0 !important;
            }
          }
          .el-form-item__label {
            padding: 0;
          }
          .el-input {
            input {
              width: 230px;
              border-radius: 20px;
              background-color: #f6f6f6;
            }
          }
        }
      }
      .fr {
        float: right;
        color: #999999;
        font-size: 12px;
        margin-top: 8px;
        p {
          img {
            width: 16px;
            vertical-align: middle;
            //   margin-right: 10px;
          }
        }
        .my-select {
          margin-left: 10px;
        }
      }
    }
  }
  //小卡片区域
  .card3 {
    margin-top: 20px;
    .el-card__body {
      display: flex;
      display: flex;
      overflow-x: scroll;
      overflow-y: hidden;
      white-space: nowrap;
    }
    // height: 1200px;

    .b1 {
      position: relative;
      &::before {
        content: "";
        width: 1px;
        height: 800px;
        background-color: #efefefff;
        position: absolute;
        right: 15px;
      }
      // &::after {
      //   content: "";
      //   position: absolute;
      //   width: 1500px;
      //   height: 1px;
      //   border: 1px solid #efefef;
      //   top: 265px;
      //   left: 20px;
      // }
      ul {
        margin-top: 15px;
        // display: flex;
        // overflow-x: scroll;
        // overflow-y: hidden;
        // white-space: nowrap;
        li {
          // display: inline-block;
          box-sizing: border-box;
          margin-bottom: 20px;
          margin-right: 30px;
          width: 271px;
          height: 146px;
          background: #ffffff;
          border-radius: 6px;
        }
        li {
          .d1 {
            padding: 15px;
            background: rgba(50, 126, 255, 0.04);
            & > div {
              margin-bottom: 10px;
              display: flex;
              justify-content: space-between;
              &:first-child {
                margin-bottom: 10px;
                img {
                  width: 16px;
                }

                span {
                  &:first-of-type {
                    width: 140px;
                  }
                  font-size: 14px;
                  font-weight: 500;
                  color: rgba(37, 49, 62, 0.85);
                }
                .b,
                .c {
                  background: rgba(255, 174, 119, 0.3);
                  border-radius: 13px;
                  padding: 4px 15px;
                  font-size: 12px;
                  font-weight: 400;
                  color: #ff812d;
                }
                .c {
                  background: rgba(85, 223, 215, 0.3);
                  color: #26c2b8;
                }
              }
              .jdt {
                align-items: center;
              }
              /deep/ .el-progress {
                width: 72% !important;
                margin: 0;
                margin-top: 10px;
              }
              /deep/ .el-progress__text {
                color: #327eff;
              }
              span {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                &:first-child {
                  display: inline-block;
                  width: 80px;
                  text-align: right;
                }
              }
            }
          }
        }
      }
    }
    .b5 {
      &::before {
        content: none;
      }
    }
    .b2,
    .b3,
    .b4 {
      position: relative;
      &::before {
        content: "";
        width: 1px;
        height: 800px;
        background-color: #efefefff;
        position: absolute;
        right: 15px;
      }
      // margin-top: 50px;
      ul {
        // overflow-x: hidden;
        // display: flex;

        li {
          //   margin-left: 100px;
          width: 271px;
          margin-top: 16px;
          margin-right: 30px;
          .d1 {
            padding: 15px;
            background: rgba(50, 126, 255, 0.04);
            & > div {
              margin-bottom: 10px;
              display: flex;
              justify-content: space-between;
              &:first-child {
                margin-bottom: 10px;
                img {
                  width: 16px;
                }

                span {
                  &:first-of-type {
                    width: 140px;
                  }
                  font-size: 14px;
                  font-weight: 500;
                  color: rgba(37, 49, 62, 0.85);
                }
                .b,
                .c {
                  background: rgba(255, 174, 119, 0.3);
                  border-radius: 13px;
                  padding: 4px 15px;
                  font-size: 12px;
                  font-weight: 400;
                  color: #ff812d;
                }
                .c {
                  background: rgba(85, 223, 215, 0.3);
                  color: #26c2b8;
                }
              }
              .jdt {
                align-items: center;
              }
              /deep/ .el-progress {
                width: 72% !important;
                margin: 0;
                margin-top: 10px;
              }
              /deep/ .el-progress__text {
                color: #327eff;
              }
              span {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                &:first-child {
                  display: inline-block;
                  width: 80px;
                  text-align: right;
                }
              }
            }
          }
          .d33 {
            display: flex;
            .target {
              font-size: 12px;
              font-weight: 500;
              color: #999999;
            }
          }
          .jdt {
            width: 283px;
            height: 1px;
            border: 2px solid #ffffff;
            margin-bottom: 15px;
          }
        }
      }
    }
    .b3 {
      // margin-top: 50px !important;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        width: 97%;
        height: 1px;
        border: 1px solid #efefef;
        top: -50px;
        left: 20px;
      }
    }
    .b4 {
      // margin-top: 50px !important;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        width: 97%;
        height: 1px;
        border: 1px solid #efefef;
        top: -50px;
        left: 20px;
      }
      .jdt {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .el-progress {
        width: 72% !important;
        margin-top: 1px;
      }
      .el-progress__text {
        margin-left: 13px;
        color: #327eff;
        text-align: right;
      }
    }
  }
  //   公共区域
  .mart {
    margin-top: 10px !important;
  }
  .colorGree {
    font-family: PingFangSC-Medium, PingFang SC !important;
    font-weight: 00 !important;
    color: #3e7603 !important;
  }
  .downColor {
    color: #19e9aa !important;
    text-align: left !important;
  }
  .blueColor {
    color: #3977fe !important;
    font-size: 20px;
    font-weight: 500;
  }
  .bblurColor {
    color: #3977fe !important;
  }
  .txt-left {
    text-align: left !important;
  }
  .radBule {
    display: inline-block;
    width: 37px;
    height: 20px;
    background: #327eff;
    border-radius: 10px;
    color: #fff;
    margin-left: 5px;
    text-align: center;
    line-height: 20px;
  }
  .fz16 {
    font-size: 16px;
  }
  .fz14 {
    font-size: 14px;
  }
}
</style>